<script setup>
/* Imports */
import {
  ref,
  onMounted,
} from 'vue';
import Container from '@garmin/components-global-vue-container';
import CoursesCard from '../components/CoursesCard.vue';

/* Props */
const props = defineProps({
  courses: {
    type: Array,
    default: () => [],
  },
});

/* Stencil reads `dataTestId` as a DOM property on the <g-*> hosts. The web
   components register after the app mounts (see entry-client.js), so Vue's
   hydration pass never applies these object props — set them imperatively so
   the `data-testid` attributes are present for downstream consumers/tests. */
const cardContainerEl = ref(null);
const applyTestIds = () => {
  if (cardContainerEl.value) {
    cardContainerEl.value.dataTestId = {
      host: 'courses-card-container-inner',
      wrapper: 'courses-card-container-wrapper',
    };
  }
};
onMounted(applyTestIds);
</script>

<template>
  <Container
    pt="md"
    pb="md"
    :dataTestId="{
      host: 'courses-card-container',
    }"
  >
    <g-card-container
      ref="cardContainerEl"
      theme="light"
      :dataTestId="{
        host: 'courses-card-container-inner',
        wrapper: 'courses-card-container-wrapper',
      }"
      :number-of-cards="Number(props.courses?.length || 0)"
      card-alignment="left"
    >
      <CoursesCard
        v-for="(course, index) in props.courses"
        :key="index"
        :course="course"
      />
    </g-card-container>
  </Container>
</template>
